// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-component {
    width: 320px;
}

.ol-control {
    position: static;
    position: initial;
}

.ol-overviewmap-box {
    background: transparent;
    border: 2px solid #C70039;
}

.ol-overviewmap {
    height: 100% !important;
    width: 100% !important;
}

.ol-overviewmap-map {
    min-width: 280px;
    min-height: 0 !important;
    min-height: initial !important;
    height: 100% !important;
    width: 100% !important;
}

.preview-map {
    position: static !important;
    position: initial !important;
    border-radius: 4px !important;
    padding: 3px !important;
    right: 0;
    top: 0;
}

#preview-map-to-target button {
    display: none!important;
}

.preview-tracking-component {
    margin-left:16px;
    margin-right:16px;
}

.preview-tracking-legend {
    font-size: 10px;
    margin: auto;
}

#preview-map-to-target .ol-viewport {
    border-radius: 5px !important;
    height: 98vh
}

#preview-map-to-target .ol-control {
    background-color: rgba(0, 0, 0, 0);
}

.preview-tracking-text, .preview-tracking-switch {
    float: right;
    font-size: 10px;
    margin: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/neoviewer/preview.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,uBAAuB;IACvB,QAAQ;IACR,MAAM;AACV;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,WAAW;AACf","sourcesContent":[".preview-component {\n    width: 320px;\n}\n\n.ol-control {\n    position: static;\n    position: initial;\n}\n\n.ol-overviewmap-box {\n    background: transparent;\n    border: 2px solid #C70039;\n}\n\n.ol-overviewmap {\n    height: 100% !important;\n    width: 100% !important;\n}\n\n.ol-overviewmap-map {\n    min-width: 280px;\n    min-height: 0 !important;\n    min-height: initial !important;\n    height: 100% !important;\n    width: 100% !important;\n}\n\n.preview-map {\n    position: static !important;\n    position: initial !important;\n    border-radius: 4px !important;\n    padding: 3px !important;\n    right: 0;\n    top: 0;\n}\n\n#preview-map-to-target button {\n    display: none!important;\n}\n\n.preview-tracking-component {\n    margin-left:16px;\n    margin-right:16px;\n}\n\n.preview-tracking-legend {\n    font-size: 10px;\n    margin: auto;\n}\n\n#preview-map-to-target .ol-viewport {\n    border-radius: 5px !important;\n    height: 98vh\n}\n\n#preview-map-to-target .ol-control {\n    background-color: rgba(0, 0, 0, 0);\n}\n\n.preview-tracking-text, .preview-tracking-switch {\n    float: right;\n    font-size: 10px;\n    margin: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
